import React from 'react';
import { Dialog, DialogProps } from '@mui/material';
import { useIsMobileSm } from '../hooks/useIsMobile';

function isLargeDialog(maxWidth: DialogProps['maxWidth']): boolean {
  return maxWidth === 'md' || maxWidth === 'lg' || maxWidth === 'xl' || maxWidth === false;
}

/**
 * Dialog plein �cran sous `sm` pour les formulaires larges (md/lg/xl).
 * Les confirms `sm` restent en overlay centr�.
 */
const ResponsiveDialog: React.FC<DialogProps> = ({
  fullScreen,
  maxWidth = 'sm',
  children,
  ...rest
}) => {
  const isMobile = useIsMobileSm();
  const shouldFullScreen = fullScreen ?? (isMobile && isLargeDialog(maxWidth));

  return (
    <Dialog fullScreen={shouldFullScreen} fullWidth maxWidth={maxWidth} {...rest}>
      {children}
    </Dialog>
  );
};

export default ResponsiveDialog;
